<div
    #header
    [ngClass]="{
        'app-content-header': !asMain,
        'fixed-top': position === 'fixed',
        'absolute-top': position === 'absolute',
    }"
>
    <nav
        class="navbar"
        [ngClass]="{
            'app-header': asMain,
            'flex-row': asMain,
            'flex-md-row': !asMain,
        }"
    >
        <ng-content></ng-content>
    </nav>
</div>

<!-- placeholder div pushes content down when content header is fixed -->
@if (placeholder && (position === "fixed" || position === "absolute")) {
    <div [ngStyle]="{ 'height.px': height }"></div>
}
